import firebase from "config/firebase";
import {FirebaseError} from "firebase/app";
import {sendPasswordResetEmail} from "firebase/auth";
import {handleError} from "helpers/errors";
import {FC, useState} from "react";
import {useNavigate} from "react-router";

const ForgotPasswordPage: FC = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  const emailValid = email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g);

  const onSubmit = () => {
    if (!emailValid) return handleError("Please enter a valid email address");
    setSubmitting(true);
    const url = window.location.origin + "/auth";
    sendPasswordResetEmail(firebase.auth, email, {url})
      .then(() => setSent(true))
      .catch((err: FirebaseError) => {
        switch (err.code) {
          case "auth/invalid-email":
            handleError("Please enter a valid email address");
            break;
          case "auth/user-disabled":
            handleError("This account has been disabled");
            break;
          case "auth/user-not-found":
            handleError("This account does not exist");
            break;
          default:
            handleError("An unknown error occurred");
        }
        setSubmitting(false);
      });
  };

  return (
    <div className="w-full bg-brand-cream h-full overflow-y-auto flex justify-center items-center">
      <div className="bg-white rounded-2xl divide-y divide-brand-border flex-cool h-max my-12 mx-4 max-w-[768px] min-w-[512px]">
        <header className="flex items-center justify-start gap-2.5 p-5">
          <img src="/akadian-logo-no-tagline.png" alt="Akadian" className="h-8 w-auto mb-4" />
          <span className="font-semibold text-xl text-brand-navy">| {sent ? "Email Sent" : "Forgot Password"}</span>
        </header>
        <main className="flex-cool p-5 gap-4">
          {sent ? (
            <span className="text-sm text-brand-navy font-medium">Check your inbox for the reset link.</span>
          ) : (
            <input type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.currentTarget.value)} />
          )}
        </main>
        <footer className="p-5 flex items-center justify-between gap-2.5">
          <span
            className="text-sm text-brand-amber hover:underline font-medium cursor-pointer"
            onClick={() => navigate("/auth")}
          >
            Sign In
          </span>
          {!sent && (
            <button disabled={submitting} onClick={onSubmit} className="btn-primary">
              Send Reset Link
            </button>
          )}
        </footer>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
